import React from "react";
import { useSelector } from "react-redux";

const PendingModal = () => {
  const pending = useSelector((state) => state.pending);
  return (
    <div
      className={` ${
        pending ? "fixed" : "hidden"
      } fixed top-0 left-0 w-[100%] h-[100%] z-40 flex  justify-center`}
    >
      {/* OverLay  */}
      <div className="absolute w-[100%] h-[100%] bg-black opacity-75" style={{ pointerEvents: 'none' }}></div>

      {/* Conetnt  */}
      <div className=" bg-transparent text-center rounded-lg w-[90%] md:w-[60%]  p-2 absolute z-50  mt-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" style={{ pointerEvents: 'auto' }}>
        {/* Modal Body  */}
        <div className="px-2 py-1 items-center justify-center my-2 h-[100%] border-purple-800 rounded flex ">
          <p className="text-white text-5xl font-semibold ">
            Sit tight. We're fetching the best movies for you.....
          </p>
        </div>
      </div>
    </div>
  );
};

export default PendingModal;
